import { useState } from "react";
import styled from "styled-components";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import axios from "axios";



// should work on it
function LaraCheckUserCourseStatus(props) {

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [certificateId, setCertificateId] = useState("");
  const [searchResult, setSearchResult] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);

  const onClickSearchInspectors = async () => {
    if (
      userEmail.trim() !== "" ||
      userName.trim() !== "" ||
      certificateId.trim() !== ""
    ) {
      try {
        setSearchLoading(true);

        const { data } = await axios.post(
          "/returnInspectorsSearchResult",
          {
            email: userEmail,
            name: userName,
            certId: certificateId,
          }
        );

        const now = new Date();

        // Step 1: find all valid (non-expired) user+course combos
        const validSet = new Set(
          data
            .filter(item =>
              item.expirationDate &&
              new Date(item.expirationDate) > now
            )
            .map(item => `${item.userEmail}-${item.courseName}`)
        );

        // Step 2: remove expired duplicates if valid exists
        const filtered = data.filter(item => {
          const isExpired =
            item.expirationDate &&
            new Date(item.expirationDate) <= now;

          const key = `${item.userEmail}-${item.courseName}`;

          return !(isExpired && validSet.has(key));
        });

        setSearchResult(filtered);

      } catch (err) {
        console.error("Search failed:", err);
      } finally {
        setSearchLoading(false);
      }
    }
  };


  return (
    <Container>
      <FilteringContainer>
        <TextField
          id="outlined-basic"
          label="Name"
          variant="outlined"
          onChange={(e) => setUserName(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { onClickSearchInspectors(); }}}
          value={userName}
        />
        <TextField
          id="outlined-basic"
          label="Email"
          variant="outlined"
          onChange={(e) => setUserEmail(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { onClickSearchInspectors(); }}}
          value={userEmail}
        />
        <TextField
          id="outlined-basic"
          label="Certification ID"
          variant="outlined"
          onChange={(e) => setCertificateId(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { onClickSearchInspectors(); }}}
          value={certificateId}
        />
        <Button
          variant="contained"
          onClick={onClickSearchInspectors}
          disabled={searchLoading}
          sx={{ minWidth: 140 }}
        >
          {searchLoading ? "Searching…" : "Search"}
        </Button>
      </FilteringContainer>
      <CustomTableContainer>
        {searchResult !== null && searchResult && searchResult.length > 0 ? (
          <TableOfContentContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: 'bold' }}>Full Name</TableCell>
                  {/* <TableCell align="left" sx={{ fontWeight: 'bold' }}>User Email</TableCell> */}
                  <TableCell align="left" sx={{ fontWeight: 'bold' }}>Course Name</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bold' }}>Certification ID</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bold' }}>Expiration Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[...searchResult]
                  .sort((a, b) => a.userName.localeCompare(b.userName))
                  .map((row, key) => (
                  <TableRow
                    key={key}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">{row.userName}</TableCell>
                    {/* <TableCell align="left">{row.userEmail}</TableCell> */}
                    <TableCell align="left">{row.courseName}</TableCell>
                    <TableCell component="th" scope="row"> {row.certificateId}</TableCell>
                    <TableCell
                      align="left"
                       sx={{ color: new Date(row.expirationDate) < new Date() ? "red" : "inherit",
                             fontWeight: new Date(row.expirationDate) < new Date() ? 600 : "normal"}}>
                      {new Date(row.expirationDate).toDateString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableOfContentContainer>
        ) : ( searchResult !== "" && searchResult.length === 0 && ( <NoResult>No Results</NoResult>  ) 
        )}
      </CustomTableContainer>
    </Container>
  );
}

export default LaraCheckUserCourseStatus;

const Container = styled.div`
  padding: 90px 20px 20px 20px;
`;

const CustomTableContainer = styled.div`
  margin-top: 15px;
  overflow-y: auto;
  scroll-behavior: smooth;
`;


const FilteringContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 0.5fr;
  justify-items: center;
  gap: 5px;
`;
const TableOfContentContainer = styled.div`
  height: 55vh;
`;

const NoResult = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  color: grey;
  font-size: 1.1rem;
  font-weight: 600;
`;
